import { MetaData, ServicePage } from '@/components'

export default function NextServicePage(props) {
  const { meta = {} } = props
  const { title: titleFromProps, description: descFromProps } = meta;
  const title = titleFromProps || props.title;
  const description = descFromProps || props.description;
  return (
    <>
      <MetaData title={title} description={description} />
      <ServicePage {...props} />
    </>
  )
}

NextServicePage.getInitialProps = async ({ query, api }) => {
  const { serviceSlug, typeSlug, ...otherQueries } = query

  const response = await api.service({ slug: serviceSlug, ...otherQueries })

  const { data } = response

  return { ...data }
}
